import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    marginBottom: theme.spacing(6)
  }
});

export default makeStyles(styles);
